<template>
  <div>
    <h2>Работы по продвижению</h2>

    <div class="row">
      <div class="col-md-12">
        <c-box
          :loading="fetching"
          shadow
        >
          <div class="c-box">
            <h3 class="title-green">
              <i class="fa fa-fw fa-calendar" />Запланированные работы
            </h3>

            <div>
              <template v-if="!fetching && works.length">
                <div
                  v-for="work of works"
                  :key="work.ЗаголовокРаботы"
                  class="work"
                >
                  <h4 class="text-uppercase">
                    {{ work.ЗаголовокРаботы }}
                  </h4>

                  <div>
                    <p style="margin-top: 5px">
                      {{ work.ОписаниеРаботы }}
                    </p>
                    <div
                      v-if="work.ТаблицаПунктовРабот"
                      class="list"
                    >
                      <p class="text-bold">
                        {{ work.ЗаголовокСписка }}
                      </p>
                      <ul>
                        <li
                          v-for="l of work.ТаблицаПунктовРабот.filter(i => i.Использовать)"
                          :key="l.Пункт"
                        >
                          {{ l.Пункт }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <hr>
                </div>
              </template>
              <no-data v-if="!fetching && !works.length" />
            </div>
          </div>
        </c-box>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import apiService from '../apiService'
import Notification from '../../../../../../resources/js/notification'
import CBox from '../../../../../../resources/js/components/ui/CBox'
import NoData from '../../../../../../resources/js/components/NoData'
import { getLatestMonthlyReportDate } from '../../../../../../resources/js/helper'

export default {
  name: 'Works',
  components: { CBox, NoData },
  data () {
    return {
      year: getLatestMonthlyReportDate().format('YYYY'),
      month: getLatestMonthlyReportDate().month(),
      fetching: true,
      works: []
    }
  },
  computed: {
    ...mapState({
      domainSelected: state => state.seo.client.domains.selected
    })
  },
  mounted () {
    if (this.domainSelected) {
      this.fetch()
    }
    this.$root.$on('clientDomainsSelectedChange', this.fetch)
  },
  destroyed () {
    this.$root.$off('clientDomainsSelectedChange', this.fetch)
  },
  methods: {
    fetch () {
      this.fetching = true

      apiService.getReport(this.domainSelected, this.year, this.month + 1)
        .then(response => {
          this.works = response.data[0].ДанныеОтчета.ДинамическиеРаботы.filter(i => i.ИмяГруппыРаботы === 'ЗапланированныеРаботы')
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить запланированные работы.'
          })
        })
        .finally(() => {
          this.fetching = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .title-green {
    padding: 10px 30px 10px 30px;
    margin: 0px -30px 40px;
    background-color: #3db613;
    color: white;
  }
  .fa-calendar {
    margin-right: 10px;
    margin-left: -5px;
  }
  .c-box {
    padding: 10px;
  }
</style>
